import { PolarAngleAxis, PolarGrid, PolarRadiusAxis, Radar, RadarChart } from "recharts";

interface RadarFigureProps {
  label: string;
  series: string;
  labels: ReadonlyArray<string>;
  data: ReadonlyArray<number>;
}

/** The radar charts the original page drew with Chart.js, one value per axis. */
export function RadarFigure({ label, series, labels, data }: RadarFigureProps) {
  const points = labels.map((name, index) => ({ name, value: data[index] ?? 0 }));
  return (
    <figure className="bazi-chart" aria-label={label}>
      <RadarChart width={340} height={280} data={points} outerRadius="70%">
        <PolarGrid />
        <PolarAngleAxis dataKey="name" tick={{ fontSize: 11 }} />
        <PolarRadiusAxis tick={{ fontSize: 10 }} />
        <Radar name={series} dataKey="value" stroke="var(--color-primary)" fill="var(--color-primary)" fillOpacity={0.3} />
      </RadarChart>
    </figure>
  );
}
